import { Flex, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const Loader = () => {
    const { t } = useTranslation("default");
    return (
        <Flex
            minH="100vh"
            w="100%"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            gap={4}
        >
            <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="brand.500"
                size="xl"
            />
            <Text color="gray.500">{t('loader.loading')}</Text>
        </Flex>
    );
};

export default Loader;
